 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"ScrollTrigger":"ScrollTrigger","components--age-gate-partial":"components--age-gate-partial","components--animations":"components--animations","components--animations-rive-widget":"components--animations-rive-widget","components--article-carousel":"components--article-carousel","components--article-intro-partial":"components--article-intro-partial","components--audio-widget":"components--audio-widget","components--banner-widget":"components--banner-widget","components--basic-picture-widget":"components--basic-picture-widget","components--basic-video-partial":"components--basic-video-partial","components--blog-carousel":"components--blog-carousel","components--breadcrumbs-partial":"components--breadcrumbs-partial","components--button-widget":"components--button-widget","components--calendar-menu":"components--calendar-menu","components--carousel-highlight":"components--carousel-highlight","components--check-drop-down":"components--check-drop-down","components--conditions-of-use":"components--conditions-of-use","components--content-block-wysiwyg":"components--content-block-wysiwyg","components--content-button":"components--content-button","components--country-specific-info-partial":"components--country-specific-info-partial","components--document-download-partial":"components--document-download-partial","components--document-list-partial":"components--document-list-partial","components--downloadpopup-widget":"components--downloadpopup-widget","components--dropdown-menu-widget":"components--dropdown-menu-widget","components--editors-pick-widget":"components--editors-pick-widget","components--error-404-widget":"components--error-404-widget","components--event-highlight-partial":"components--event-highlight-partial","components--faq":"components--faq","components--faq-block":"components--faq-block","components--footer-list":"components--footer-list","components--footer-nav":"components--footer-nav","components--gallery-item":"components--gallery-item","components--glossary":"components--glossary","components--highlight-image":"components--highlight-image","components--highlight-image-partial":"components--highlight-image-partial","components--highlight-text-on-image":"components--highlight-text-on-image","components--highlight-text-on-image-partial":"components--highlight-text-on-image-partial","components--ie-warning":"components--ie-warning","components--image-fade":"components--image-fade","components--initiative":"components--initiative","components--interactive-map":"components--interactive-map","components--interactive-wheel":"components--interactive-wheel","components--investor-cta-widget":"components--investor-cta-widget","components--investor-cta-widget-blue":"components--investor-cta-widget-blue","components--investor-events-overview":"components--investor-events-overview","components--investor-highlight":"components--investor-highlight","components--ir-annual-reports":"components--ir-annual-reports","components--ir-email-alerts-widget":"components--ir-email-alerts-widget","components--ir-event-detail-widget":"components--ir-event-detail-widget","components--ir-event-highlight":"components--ir-event-highlight","components--ir-search":"components--ir-search","components--ir-search-results":"components--ir-search-results","components--ir-share-history-calculator":"components--ir-share-history-calculator","components--ir-share-price-overview":"components--ir-share-price-overview","components--job-details":"components--job-details","components--job-list":"components--job-list","components--job-list-pages":"components--job-list-pages","components--job-search-partial":"components--job-search-partial","components--key-figures-icon":"components--key-figures-icon","components--key-survey":"components--key-survey","components--large-image-text-on-image":"components--large-image-text-on-image","components--large-image-text-on-image-partial":"components--large-image-text-on-image-partial","components--latest-article-popup-widget":"components--latest-article-popup-widget","components--latest-press-releases":"components--latest-press-releases","components--leadership-widget":"components--leadership-widget","components--market-contact-map":"components--market-contact-map","components--market-redirect-widget":"components--market-redirect-widget","components--medium-text-on-image":"components--medium-text-on-image","components--modal-video":"components--modal-video","components--news-releases-article":"components--news-releases-article","components--newsroom":"components--newsroom","components--null-check":"components--null-check","components--page-info-widget-image-partial":"components--page-info-widget-image-partial","components--pages-nav":"components--pages-nav","components--pop-up-newsletter":"components--pop-up-newsletter","components--press-release-details-widget":"components--press-release-details-widget","components--quarterly-reports":"components--quarterly-reports","components--related-articles-partial":"components--related-articles-partial","components--related-category":"components--related-category","components--related-faq":"components--related-faq","components--scrollable-content":"components--scrollable-content","components--search-box-results-page":"components--search-box-results-page","components--search-results-partial":"components--search-results-partial","components--section-highlight":"components--section-highlight","components--show-more-widget":"components--show-more-widget","components--small-image-above-title":"components--small-image-above-title","components--small-image-above-title-partial":"components--small-image-above-title-partial","components--small-text-on-image":"components--small-text-on-image","components--small-written-by":"components--small-written-by","components--social-highlight":"components--social-highlight","components--social-list":"components--social-list","components--social-media-highlights":"components--social-media-highlights","components--social-share":"components--social-share","components--social-share-collapse":"components--social-share-collapse","components--specific-event-highlight":"components--specific-event-highlight","components--sustainability":"components--sustainability","components--sustainability-qa-block":"components--sustainability-qa-block","components--tab-widget":"components--tab-widget","components--table-widget":"components--table-widget","components--table-widget-ir":"components--table-widget-ir","components--tag-results":"components--tag-results","components--tbe-journey":"components--tbe-journey","components--timeline-widget":"components--timeline-widget","components--tobacco-economics":"components--tobacco-economics","components--topic-highlight":"components--topic-highlight","components--topic-highlight-partial":"components--topic-highlight-partial","components--unfoldable-list":"components--unfoldable-list","components--unsmoke-small-text-on-image":"components--unsmoke-small-text-on-image","components--video":"components--video","components--video-carousel-pop-up":"components--video-carousel-pop-up","components--video-highlight-full-width":"components--video-highlight-full-width","components--videos-highlight":"components--videos-highlight","gsap":"gsap","vendors~animejs":"vendors~animejs","vendors~components--filters-partial~components--ingredient-finder~components--news-releases-block~co~eda16230":"vendors~components--filters-partial~components--ingredient-finder~components--news-releases-block~co~eda16230","components--filters-partial":"components--filters-partial","components--ingredient-finder":"components--ingredient-finder","components--news-releases-block":"components--news-releases-block","components--sec-filing":"components--sec-filing","components--sustainability-filter":"components--sustainability-filter","vendors~debounce-throttle":"vendors~debounce-throttle","debounce-throttle":"debounce-throttle","vendors~hammerjs":"vendors~hammerjs","vendors~pikaday":"vendors~pikaday","vendors~plyr":"vendors~plyr","vendors~sticky-js":"vendors~sticky-js","vendors~tiny-slider":"vendors~tiny-slider","vendors~qrcode":"vendors~qrcode","vendors~tbe":"vendors~tbe","tbe":"tbe"}[chunkId]||chunkId) + "" + "299af21d05a0f2fe6759" + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/assets-v3/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = "./src/js/modern.js");
